import { createAsyncThunk } from "@reduxjs/toolkit";
// urls
import * as URLS from "../../../urls";
//axios
import axios from "../../utilies/axios";
//_________________________________________________

// GET =>  All ALL TRAINERS SERVICE
export const getTrainersService = createAsyncThunk(
  "trainers/getTrainersService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.trainersURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// POST =>  CREATE TRAINER SERVICE
export const createTrainerService = createAsyncThunk(
  "trainers/createTrainerService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(URLS.trainersURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// DELETE =>  DELETE TRAINER SERVICE
export const deleteTrainerService = createAsyncThunk(
  "trainers/deleteTrainerService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.delete(`${URLS.trainersURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// UPDATE =>  UPDATE TRAINER SERVICE
export const updateTrainerService = createAsyncThunk(
  "trainers/updateTrainerService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.trainersURL}/${params?.id}`,
        params.formData
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// GET =>  GET TRAINER BY ID SERVICE
export const getTrainerByIdService = createAsyncThunk(
  "trainers/getTrainerByIdService",
  async (id, thunkAPI) => {
    try {
      const response = await axios.get(`${URLS.trainersURL}/${id}`);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
